namespace RioERP.Carts {
    export namespace CartService {
        export const baseUrl = 'Carts/Cart';

        export declare function Create(request: Serenity.SaveRequest<CartRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<CartRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<CartRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function RetrieveFranchiseeCart(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<CartRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function RemoveProductFromCart(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<CartRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function RetrieveOrder(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<CartRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<CartRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Carts/Cart/Create",
            Update = "Carts/Cart/Update",
            Delete = "Carts/Cart/Delete",
            Retrieve = "Carts/Cart/Retrieve",
            RetrieveFranchiseeCart = "Carts/Cart/RetrieveFranchiseeCart",
            RemoveProductFromCart = "Carts/Cart/RemoveProductFromCart",
            RetrieveOrder = "Carts/Cart/RetrieveOrder",
            List = "Carts/Cart/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'RetrieveFranchiseeCart', 
            'RemoveProductFromCart', 
            'RetrieveOrder', 
            'List'
        ].forEach(x => {
            (<any>CartService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
